export namespace FansAssets {
  const BASE_URL = `https://assets.iyk.app/music/fans`

  export const images = {
    home: {
      emptyStateBanner: `${BASE_URL}/home/crowd.webp`
    },
    clips: {
      portraitCards: {
        left: `${BASE_URL}/fan-clips/cards/1.png`,
        center: `${BASE_URL}/fan-clips/cards/2.png`,
        right: `${BASE_URL}/fan-clips/cards/3.png`
      }
    },
    enableLocation: {
      prompt: `${BASE_URL}/check-in/enable_location_prompt.png`,
      ios: {
        step1: `${BASE_URL}/check-in/enable_location_ios_1.png`,
        step2: `${BASE_URL}/check-in/enable_location_ios_2.png`
      },
      android: {
        step1: `${BASE_URL}/check-in/enable_location_android.png`
      }
    }
  }

  export const videos = {
    clips: {
      portraitCards: {
        left: `${BASE_URL}/fan-clips/cards/1.mp4`,
        center: `${BASE_URL}/fan-clips/cards/2.mp4`,
        right: `${BASE_URL}/fan-clips/cards/3.mp4`
      }
    }
  }
}
